import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import UserStore from 'stores/UserStore';
import TokenHolderIndicatorAvatar from 'components/TokenHolderIndicatorAvatar';

import sharedStyles from '../../ChatMessageTypes.css';

import styles from './index.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const Avatar = (props) => {
  const {
    hasTokens,
    hideRecentSpendingTierIndicator,
    isBroadcasterChat,
    recentSpendingTier,
    username,
    onClick,
  } = props;

  const { user: { sfw } } = UserStore;

  if (isBroadcasterChat) {
    return (
      <TokenHolderIndicatorAvatar
        avatarClassName={sharedStyles.avatar}
        hasTokens={hasTokens}
        isBasicAvatar={hideRecentSpendingTierIndicator}
        recentSpendingTier={recentSpendingTier}
        username={username}
        onClick={onClick}
      />
    );
  }

  const avatarClasses = classNames({
    [sharedStyles.avatar]: true,
    [styles.avatar]: true,
    [styles.blur]: sfw,
  });

  return (
    <div className={avatarClasses}>
      <img
        alt="avatar"
        className={styles.image}
        src={`${BASE_URL}/avatar/user/60x60/${username}.jpg`}
        onClick={onClick}
      />
    </div>
  );
};

Avatar.propTypes = {
  username: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  hasTokens: PropTypes.bool,
  hideRecentSpendingTierIndicator: PropTypes.bool,
  isBroadcasterChat: PropTypes.bool,
  recentSpendingTier: PropTypes.number,
};

Avatar.defaultProps = {
  hasTokens: false,
  hideRecentSpendingTierIndicator: false,
  isBroadcasterChat: false,
  recentSpendingTier: undefined,
};

export default observer(Avatar);
